'use client'

import { ErrorPage } from '@/modules/app/error-page'
import { useEffect, useState } from 'react'
import {
  EXPIRED_PARAM_TOKEN_VALUE,
  HOME_ERROR_PARAM,
  INVALID_TOKEN_ERROR_MESSAGE,
} from '@/modules/auth/constants'
import posthog from 'posthog-js'
import { usePathname, useRouter } from 'next/navigation'
import { MainRoutes } from '@/utils/routes'

/**
 * https://nextjs.org/docs/app/building-your-application/routing/error-handling
 */
export default function Error({
  error,
}: {
  error: Error & { digest?: string }
}) {
  const { push } = useRouter()
  const pathname = usePathname()
  const [isCheckingError, setIsCheckingError] = useState(true)

  useEffect(() => {
    if (
      pathname !== MainRoutes.Logout &&
      error.message.includes(INVALID_TOKEN_ERROR_MESSAGE)
    ) {
      push(
        `${MainRoutes.Logout}?${HOME_ERROR_PARAM}=${EXPIRED_PARAM_TOKEN_VALUE}`,
      )
      return
    }

    posthog.captureException('error-boundary', {
      // https://github.com/getsentry/sentry-javascript/discussions/10071
      captureContext: {
        level: 'error',
        extra: { error },
        tags: { digest: error.digest },
      },
    })
    console.warn('[POSTHOG_DETECTION_ID]:error-boundary', error)
    setIsCheckingError(false)
  }, [error, push, pathname, setIsCheckingError])

  if (isCheckingError) {
    return null
  }

  return (
    <>
      <ErrorPage />
    </>
  )
}
